export default "__VITE_ASSET__H3StsucZ__"